export const PHONE = 'phone';
export const DESKTOP = 'desktop';
export const TABLET = 'tablet';
